import { httpService } from '@/services/HttpService';

class AccountSettingsService {
  getSettings(): Promise<any> {
    return httpService.get(`account_setting`);
  }
  updateAccountName(accountName: any): Promise<any> {
    return httpService.put(`account_setting`, accountName);
  }
  updateEmail(email: any): Promise<any> {
    return httpService.put(`account_setting/email`, email);
  }
  updatePassword(passwordData: any): Promise<any> {
    return httpService.put(`account_setting/password`, passwordData);
  }
  confirmEmail(token: string): Promise<any> {
    return httpService.put(`account_setting/confirm_email_change`, { token });
  }
  getSshKeys(): Promise<any> {
    return httpService.get(`ssh_keys`);
  }
  createSshKey(sshKeyData: any): Promise<any> {
    return httpService.post(`ssh_keys`, sshKeyData);
  }
  deleteSshKey(sshKeyId: number): Promise<any> {
    return httpService.delete(`ssh_keys/${sshKeyId}`, '');
  }
  deleteAccount(): Promise<any> {
    return httpService.delete(`account_setting/`, '', {}, { isErrorSuppressed: true });
  }
  getActiveSessions(): Promise<any> {
    return httpService.get(`sessions/active`);
  }
  sessionSignOut(sessionId: number): Promise<any> {
    return httpService.delete(`sessions/${sessionId}`, '', {}, { isErrorSuppressed: true });
  }
}

export const accountSettingsService = new AccountSettingsService();
